import type { RiskBadgeProps } from "./risk-badge.type";

import { Badge } from "antd";

import { riskDisplayLabel } from "@/modules/risk";

import "./risk-badge.style.less";

export const RiskBadge = ({ risk }: RiskBadgeProps) => {
  return (
    <Badge
      text={riskDisplayLabel(risk)}
      color={risk.color}
      className="risk-badge"
    />
  );
};
